import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30c39953"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "td" }
const _hoisted_3 = {
  key: 2,
  class: "td"
}

import { DataNode } from '@/components/common/tree/TreeUtil';
import ScDrop from '@/components/common/drag/ScDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceNode',
  props: {
    node: {}
  },
  emits: ["move"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_tag = _resolveComponent("a-tag")!

  return (_openBlock(), _createBlock(_unref(ScDrop), {
    accept: "node",
    onDrop: _cache[1] || (_cache[1] = ($event: any) => (emit('move', [JSON.parse($event.data), _ctx.node, 'inside'])))
  }, {
    default: _withCtx(({ hover }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["line", { hover }])
      }, [
        _createElementVNode("span", {
          class: "arrow",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.node.setOpen(!_ctx.node.opened)))
        }, [
          _withDirectives(_createVNode(_component_sc_icon, {
            type: _ctx.node.opened ? 'CaretDownOutlined' : 'CaretRightOutlined'
          }, null, 8, ["type"]), [
            [_vShow, _ctx.node.children.length > 0]
          ])
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_sc_icon, { type: "FolderTwoTone" }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.node.data.name), 1),
          (_ctx.node.data.group)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 0,
                color: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.node.data.group?.name), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.node.data.tags)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.node.data.tags.list, (item, k) => {
                return (_openBlock(), _createBlock(_component_a_tag, {
                  color: "green",
                  key: k
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.node.data.remark)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.node.data.remark), 1))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})